<app-banner></app-banner>
<app-header></app-header>

<div class="w-450px">
  <iui-messages #globalmessage class="ms-auto me-auto"></iui-messages>
</div>

<div class="container-fluid">
  <router-outlet></router-outlet>
</div>

<p-toast position="top-right"></p-toast>

<iui-busy></iui-busy>

<app-inactivity></app-inactivity>

<app-footer></app-footer>

<app-id-token-dialog [app]="this"></app-id-token-dialog>

<app-utilities-dialog [app]="this"></app-utilities-dialog>

<app-new-version-dialog></app-new-version-dialog>



<p-dialog #signedOut header="Please Sign in Again" [(visible)]="displaySignedOutDialog" [modal]="true"
  [style]="{width: '400'}" [closable]="false" [focusOnShow]="false">
  You were logged out of your account or have already signed in on a different browser tab.
  <p-footer>
    <button i18n id="signedOutDialogOk" class="btn btn-primary" (click)="reloadDueToSignOut()">OK</button>
  </p-footer>
</p-dialog>